import { createNativeStackNavigator, NativeStackScreenProps } from '@react-navigation/native-stack';
import * as React from 'react';
import { GetBrokersResponseItem } from '../../../../packages/utx-client/src/react';
import { ConfirmExchangeNavigator } from './screens/confirm/confirm-exchange.navigator';
import { InstructionSubmittedScreen } from './screens/instruction-submitted/InstructionSubmitted.screen';
import { ExchangeIntroductionScreen } from './screens/Introduction/ExchangeIntroduction.screen';
import { SelectExchangeScreen } from './screens/select-exchange/SelectExchange.screen';
import { ExchangeSplashScreen } from './screens/splash/ExchangeSplash.screen';

export enum ExchangeSubAccountStackRoutes {
  Splash = 'exchange-splash',
  Introduction = 'exchange-introduction',
  SelectExchange = 'exchange-select',
  InstructionSubmitted = 'exchange-submit',
  ConfirmExchange = 'exchange-confirm'
}

export type ExchangeSubAccountStackParamList = {
  [ExchangeSubAccountStackRoutes.Splash]: undefined;
  [ExchangeSubAccountStackRoutes.Introduction]: undefined;
  [ExchangeSubAccountStackRoutes.SelectExchange]: undefined;
  [ExchangeSubAccountStackRoutes.InstructionSubmitted]: undefined;
  [ExchangeSubAccountStackRoutes.ConfirmExchange]: { data: GetBrokersResponseItem; shouldBeFetchFee: boolean; onResult: () => void };
};

export type ExchangeSubAccountStackScreenProps<Screen extends keyof ExchangeSubAccountStackParamList> = NativeStackScreenProps<
  ExchangeSubAccountStackParamList,
  Screen
>;

const ExchangeSubAccountStack = createNativeStackNavigator<ExchangeSubAccountStackParamList>();

export function ExchangeSubAccountNavigator(): JSX.Element {
  return (
    <ExchangeSubAccountStack.Navigator
      screenOptions={{
        headerShown: false
      }}
      initialRouteName={ExchangeSubAccountStackRoutes.Splash}>
      <ExchangeSubAccountStack.Screen name={ExchangeSubAccountStackRoutes.Splash} component={ExchangeSplashScreen} />
      <ExchangeSubAccountStack.Screen name={ExchangeSubAccountStackRoutes.Introduction} component={ExchangeIntroductionScreen} />
      <ExchangeSubAccountStack.Screen name={ExchangeSubAccountStackRoutes.SelectExchange} component={SelectExchangeScreen} />
      <ExchangeSubAccountStack.Screen name={ExchangeSubAccountStackRoutes.InstructionSubmitted} component={InstructionSubmittedScreen} />
      <ExchangeSubAccountStack.Screen
        name={ExchangeSubAccountStackRoutes.ConfirmExchange}
        component={ConfirmExchangeNavigator}
        options={{ presentation: 'transparentModal' }}
      />
    </ExchangeSubAccountStack.Navigator>
  );
}
